import { useEffect, useState } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import Avatar from "@components/avatar";
import logo from "@src/assets/images/logo.png";
import { isUserLoggedIn } from "@utils";
import { useDispatch } from "react-redux";
import { handleLogout } from "@store/actions/auth";
import { User, Menu, X, LogOut } from "react-feather";
import defaultAvatar from "@src/assets/images/avatars/avatar-blank.png";
import { PropTypes } from "prop-types";
import classnames from "classnames";

const VerticalMenuHeader = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(
        JSON.parse(localStorage.getItem(`${process.env.REACT_APP_USERDATA}`))
      );
    }
  }, []);

  const userAvatar = (userData && userData.logo) || defaultAvatar;
  const {
    menuCollapsed,
    setMenuCollapsed,
    setMenuVisibility,
    setGroupOpen,
    menuHover,
  } = props;

  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([]);
  }, [menuHover, menuCollapsed]);

  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <X
          size={20}
          data-tour="toggle-icon"
          className="text-black toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(true)}
        />
      );
    } else {
      return (
        <Menu
          size={20}
          data-tour="toggle-icon"
          className="text-black toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(false)}
        />
      );
    }
  };

  const logoutUser = () => {
    dispatch(handleLogout());
    history.push("/login");
  };

  return (
    <>
      <div className="navbar-header">
        <ul className="nav navbar-nav flex-row">
          <li className="nav-item mr-auto">
            <NavLink to="/dashboard/brands" className="navbar-brand">
              <span className="brand-logo">
                <img
                  src={logo}
                  alt="logo"
                  className={classnames({
                    "w-50": menuCollapsed && !menuHover,
                  })}
                />
              </span>
            </NavLink>
          </li>
          <li className="nav-item nav-toggle">
            <div className="nav-link modern-nav-toggle cursor-pointer">
              <Toggler />
              <X
                onClick={() => setMenuVisibility(false)}
                className="toggle-icon icon-x d-block d-xl-none"
                size={20}
              />
            </div>
          </li>
        </ul>
      </div>
      <div className="userDropDown-sidebar">
        <ul>
          <div className="user-nav d-sm-flex d-none flex-row align-items-center flex-wrap">
            <div className="col text-center">
              <Avatar
                className="avatar-img-fit-contain"
                img={userAvatar}
                imgHeight="90"
                imgWidth="90"
              />
            </div>
            <div className="col">
              <Link
                to="/dashboard/brands"
                className="user-name text-dark font-weight-bold"
              >
                {userData?.brand_name}
              </Link>
              <ul className="d-flex justify-content-between flex-wrap">
                <li className="mt-1">
                  <NavLink
                    to="/dashboard/brands/profile"
                    className="btn btn-primary btn-sm"
                  >
                    <User size={14} />
                  </NavLink>
                </li>

                <li className="mt-1">
                  <button
                    onClick={logoutUser}
                    className="btn btn-danger btn-sm"
                  >
                    <LogOut size={14} />
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </ul>
      </div>
    </>
  );
};

VerticalMenuHeader.propTypes = {
  menuCollapsed: PropTypes.bool,
  setMenuCollapsed: PropTypes.func,
  setMenuVisibility: PropTypes.func,
  setGroupOpen: PropTypes.func,
  menuHover: PropTypes.bool,
};

export default VerticalMenuHeader;
